<template lang="pug">
  .age-background
    .age-wrapper
      .age-modal(role="dialog", aria-labelledby="ageVerificationModal")
        h1 Are you over 21?
        .border
          img#age-accent(src="../assets/img/ppr-modal-border-accent.svg", alt="", draggable="false")
          #divider
        p You must be 21 to access this site.
        #age-buttons
          button.button#yes(v-on:click="verifyAge") Yes, I am over 21
          a.button#no(href="javascript:history.go(-1)") No, I am under 21
</template>

<script>
export default {
  name: 'AgeModal',
  methods: {
    verifyAge () {
      this.$cookies.set("ppr_ageVerified", true, "24d")
      let ageVerified = this.$cookies.get("ppr_ageVerified")
      if (ageVerified === 'true') {
        document.querySelector('body').setAttribute('class', '')
      } else {
        document.querySelector('body').setAttribute('class', 'overlay')
      }
    }
  }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/helpers/mixins.styl'

.age-background
  background-color rgba(4,4,4,0.8)
  height 100vh
  position fixed
  display none
  width 100vw
  z-index 100000
  .age-wrapper
    height 100vh
    position relative
    width 100vw
    .age-modal
      background-color rgba(254,254,254,1)
      border-radius 10px
      height 100%
      left 50%
      max-height 25rem
      max-width 40rem
      position absolute
      top 50%
      transform translate(-50%, -50%)
      width 100%
      h1
        color $brown
        padding 4.5rem 0 2rem 0
        max-width 30rem
        margin-left auto
        margin-right auto
        width 100%
      p
        max-width 30rem
        margin 4.5rem auto 3rem auto
        width 100%
      .border
        position relative
        img
          max-width 5.5rem
          position absolute
          right 4rem
          top -2.75rem
          width 100%
        #divider
          height 1px
          border-bottom 2px solid $green
          position absolute
          width 100%
      #age-buttons
        max-width 30rem
        margin-left auto
        margin-right auto
        width 100%
        #yes
          margin-right 1rem
          background-color $green-tint
          &:hover
            background-color $green
        #no
          background-color $gray-tint
          &:hover
            background-color $gray

    @media (max-width: 42rem)
      .age-modal
        width 80%
        h1, p, #age-buttons
          width 80%
        h1
          padding 3rem 0 2rem 0
        p
          margin 3rem auto 2rem auto
        .border > img
          display none
        #age-buttons
          display flex
          flex-direction column
          text-align center
          #yes
            margin-right 0
            margin-bottom 1rem
</style>
